import { BlocksIconShieldCheck } from 'blocks-nextjs/blocks-web-components/components/icon/icons/shield-check';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconShieldCheck = createComponent({ react: React, tagName: 'cat-icon-shield-check', elementClass: BlocksIconShieldCheck });
